import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageHistoryService {
  private subject = new Subject<any>();

  public getPageHistory(): Observable<any> {
    return this.subject.asObservable();
  }

  public setPageHistory(data: string[]) {
    localStorage.setItem('page-history', JSON.stringify(data));
    this.subject.next(data);
  }

  public updatePageHistory(newHistoryItem: string, filter: string) {
    const pageHistory: string[] = JSON.parse(localStorage.getItem('page-history')) ?? [];
    const newHistory: Array<string> = [];
    const filterRegex = new RegExp(filter, 'i');
    pageHistory.forEach(existingHistoryItem => {
      if (existingHistoryItem.search(filterRegex) === -1) {
        newHistory.push(existingHistoryItem);
      }
    });
    newHistory.push(newHistoryItem);
    localStorage.setItem('page-history', JSON.stringify(newHistory));
    this.subject.next(newHistory);
  }

  public pageHistoryBack(): string {
    const pageHistory: string[] = JSON.parse(localStorage.getItem('page-history'));
    if (pageHistory.length > 1) {
      pageHistory.pop();
    }

    localStorage.setItem('page-history', JSON.stringify(pageHistory));
    this.subject.next(pageHistory);
    return pageHistory[pageHistory.length - 1];
  }

  public clearPageHistory() {
    localStorage.setItem('page-history', JSON.stringify([]));
    this.subject.next([]);
  }
}
